export const platforms = [
  {
    id: 'p-minsheng',
    name: '民生观察台',
    short: '民',
    categoryId: 'general',
    categoryName: '综合爆料门户',
    url: 'https://luosai123.cn/minsheng',
    description:
      '以民生议题为主的综合爆料大厅，支持匿名投递与多轮跟进，编辑会对线索做基础核实后再公开。',
    tags: ['匿名投递', '编辑跟进', '民生热点'],
    region: '全国',
    heat: 96,
    rating: 4.8,
    verified: true,
    updatedAt: '2026-09-06',
  },
  {
    id: 'p-chengshi',
    name: '城市热点直击',
    short: '城',
    categoryId: 'city',
    categoryName: '城市本地',
    url: 'https://luosai123.cn/chengshi',
    description:
      '按城市划分版块的本地爆料入口，市政道路、社区治理与突发状况都能就近发布并@本地跟进人。',
    tags: ['按城市', '就近发布', '突发线索'],
    region: '全国 300+ 城市',
    heat: 92,
    rating: 4.7,
    verified: true,
    updatedAt: '2026-09-05',
  },
  {
    id: 'p-weiqan',
    name: '消费维权在线',
    short: '权',
    categoryId: 'rights',
    categoryName: '民生消费维权',
    url: 'https://luosai123.cn/weiqan',
    description:
      '面向普通消费者的维权爆料平台，支持上传订单截图与沟通记录，常被用来推动商家正面回应。',
    tags: ['订单凭证', '商家回应', '退款纠纷'],
    region: '全国',
    heat: 94,
    rating: 4.9,
    verified: true,
    updatedAt: '2026-09-08',
  },
  {
    id: 'p-caijing',
    name: '财经真相局',
    short: '财',
    categoryId: 'finance',
    categoryName: '财经金融观察',
    url: 'https://luosai123.cn/caijing',
    description:
      '聚焦理财兑付、平台跑路与企业失信线索，设有材料预审环节，对来源不明的信息会标注存疑。',
    tags: ['材料预审', '兑付线索', '风险提示'],
    region: '全国',
    heat: 85,
    rating: 4.6,
    verified: true,
    updatedAt: '2026-09-04',
  },
  {
    id: 'p-loushi',
    name: '楼市显微镜',
    short: '楼',
    categoryId: 'life',
    categoryName: '生活服务',
    url: 'https://luosai123.cn/loushi',
    description:
      '交付延期、精装缩水、物业收费不透明等房产问题的爆料汇总，配有合同条款对照参考。',
    tags: ['交付延期', '合同对照', '物业问题'],
    region: '全国',
    heat: 80,
    rating: 4.5,
    verified: false,
    updatedAt: '2026-09-02',
  },
  {
    id: 'p-chezhi',
    name: '车市质检站',
    short: '车',
    categoryId: 'auto',
    categoryName: '汽车出行',
    url: 'https://luosai123.cn/chezhi',
    description:
      '车辆质量与售后维保类爆料专区，按品牌与车型归档，便于同类车主快速找到同伴案例。',
    tags: ['按车型', '售后维保', '质量反馈'],
    region: '全国',
    heat: 78,
    rating: 4.5,
    verified: true,
    updatedAt: '2026-09-03',
  },
  {
    id: 'p-shuma',
    name: '数码真话社区',
    short: '数',
    categoryId: 'tech',
    categoryName: '科技数码',
    url: 'https://luosai123.cn/shuma',
    description:
      '数码产品实测与翻车案例分享，鼓励附上购买渠道、批次与实测数据，反对无依据的品牌抹黑。',
    tags: ['实测数据', '批次信息', '反抹黑'],
    region: '全国',
    heat: 83,
    rating: 4.6,
    verified: false,
    updatedAt: '2026-09-07',
  },
  {
    id: 'p-jiaoyu',
    name: '教育曝光台',
    short: '教',
    categoryId: 'workplace',
    categoryName: '教育职场',
    url: 'https://luosai123.cn/jiaoyu',
    description:
      '培训退费、虚假宣传与校园服务的线索收集入口，提供投诉模板与退费协商步骤参考。',
    tags: ['退费协商', '虚假宣传', '投诉模板'],
    region: '全国',
    heat: 76,
    rating: 4.4,
    verified: false,
    updatedAt: '2026-09-01',
  },
  {
    id: 'p-zichang',
    name: '职场权益议事厅',
    short: '职',
    categoryId: 'workplace',
    categoryName: '教育职场',
    url: 'https://luosai123.cn/zichang',
    description:
      '欠薪、裁员补偿、试用期套路等职场议题的爆料与讨论空间，附有劳动仲裁流程指引。',
    tags: ['欠薪', '裁员补偿', '仲裁指引'],
    region: '全国',
    heat: 88,
    rating: 4.7,
    verified: true,
    updatedAt: '2026-09-06',
  },
  {
    id: 'p-fanzha',
    name: '反诈预警中心',
    short: '反',
    categoryId: 'finance',
    categoryName: '财经金融观察',
    url: 'https://luosai123.cn/fanzha',
    description:
      '电信诈骗、杀猪盘与荐股陷阱的最新手法预警，支持一键检索相似话术，便于快速比对。',
    tags: ['话术检索', '手法预警', '快速比对'],
    region: '全国',
    heat: 90,
    rating: 4.9,
    verified: true,
    updatedAt: '2026-09-09',
  },
  {
    id: 'p-shipin',
    name: '食品药品追踪',
    short: '食',
    categoryId: 'rights',
    categoryName: '民生消费维权',
    url: 'https://luosai123.cn/shipin',
    description:
      '食品安全与药品相关的线索报送通道，支持按批次与生产日期检索，来源信息会做留存标注。',
    tags: ['批次检索', '来源留存', '安全线索'],
    region: '全国',
    heat: 87,
    rating: 4.8,
    verified: true,
    updatedAt: '2026-09-05',
  },
  {
    id: 'p-huanjing',
    name: '环境监督哨',
    short: '环',
    categoryId: 'general',
    categoryName: '综合爆料门户',
    url: 'https://luosai123.cn/huanjing',
    description:
      '面向噪音、排污与生态破坏议题的监督爆料入口，鼓励附定位与时间线，方便后续跟进。',
    tags: ['定位线索', '时间线', '生态监督'],
    region: '全国',
    heat: 72,
    rating: 4.5,
    verified: false,
    updatedAt: '2026-08-30',
  },
  {
    id: 'p-wenyu',
    name: '文娱风评站',
    short: '娱',
    categoryId: 'general',
    categoryName: '综合爆料门户',
    url: 'https://luosai123.cn/wenyu',
    description:
      '文化娱乐行业的从业者见闻与作品争议汇总，明确要求区分事实描述与主观评价。',
    tags: ['从业见闻', '事实与评价分离', '作品争议'],
    region: '全国',
    heat: 74,
    rating: 4.3,
    verified: false,
    updatedAt: '2026-08-29',
  },
  {
    id: 'p-yinhang',
    name: '银发消费守望',
    short: '银',
    categoryId: 'rights',
    categoryName: '民生消费维权',
    url: 'https://luosai123.cn/yinfa',
    description:
      '专门关注老年群体消费陷阱的爆料专区，涵盖保健品、理财与养老服务等高风险场景。',
    tags: ['老年消费', '保健品', '高风险场景'],
    region: '全国',
    heat: 79,
    rating: 4.6,
    verified: true,
    updatedAt: '2026-09-02',
  },
  {
    id: 'p-xianyu',
    name: '县域民生通',
    short: '县',
    categoryId: 'city',
    categoryName: '城市本地',
    url: 'https://luosai123.cn/xianyu',
    description:
      '下沉市场与县域用户常用的本地爆料广场，话题偏向日常出行、水电燃气与乡镇服务。',
    tags: ['本地生活', '乡镇服务', '日常出行'],
    region: '县域',
    heat: 68,
    rating: 4.4,
    verified: false,
    updatedAt: '2026-08-28',
  },
  {
    id: 'p-shouhou',
    name: '家电售后监督',
    short: '家',
    categoryId: 'life',
    categoryName: '生活服务',
    url: 'https://luosai123.cn/shouhou',
    description:
      '家电安装、维修报价与上门服务纠纷的爆料入口，按服务网点整理避坑提示。',
    tags: ['维修报价', '上门服务', '避坑提示'],
    region: '全国',
    heat: 66,
    rating: 4.3,
    verified: false,
    updatedAt: '2026-08-27',
  },
  {
    id: 'p-yundong',
    name: '体育票务反馈',
    short: '体',
    categoryId: 'general',
    categoryName: '综合爆料门户',
    url: 'https://luosai123.cn/tiyu',
    description:
      '赛事票务、场馆服务与观赛体验的反馈专区，支持按赛事名称快速检索同类反馈。',
    tags: ['票务退改', '场馆服务', '观赛体验'],
    region: '全国',
    heat: 61,
    rating: 4.2,
    verified: false,
    updatedAt: '2026-08-26',
  },
  {
    id: 'p-zhaopin',
    name: '招聘套路显微镜',
    short: '招',
    categoryId: 'workplace',
    categoryName: '教育职场',
    url: 'https://luosai123.cn/zhaopin',
    description:
      '针对招聘收费、岗位描述失真与试用期辞退的爆料板，鼓励附聊天记录并隐去个人信息。',
    tags: ['招聘收费', '岗位失真', '隐私处理'],
    region: '全国',
    heat: 81,
    rating: 4.6,
    verified: true,
    updatedAt: '2026-09-04',
  },
];